import api from './api'

const SideNavDataProvider = {
  sideLinks() {
    return api.get('Sidebar/api/SidebarMenu/SidebarMenu')
  },
}

export default SideNavDataProvider
